module.exports = __webpack_public_path__ + "static/ccpa-eda1f90470d3088d1daa3dd9528293cc.pdf";